// extracted by mini-css-extract-plugin
export var box = "_73-1";
export var checkboxRow = "_73-8";
export var checked = "_73-2";
export var descriptionSpacer = "_73-a";
export var disabled = "_73-3";
export var icon = "_73-6";
export var input = "_73-0";
export var labelSpacer = "_73-9";
export var medium = "_73-5";
export var small = "_73-4";
export var text = "_73-7";